import React from 'react';

const VideoCard = ({ thumbnail, title, onClick }) => {
    return (
        <div 
            onClick={onClick}
            className="relative w-full aspect-[4/3] rounded-3xl overflow-hidden cursor-pointer group border-2 border-purple-500/30 shadow-[0_0_20px_rgba(168,85,247,0.2)] transition-all transform hover:scale-[1.02]"
        >
            {/* Background Image */}
            <div 
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                style={{ backgroundImage: `url(${thumbnail})` }}
            ></div>
            
            {/* Overlay */}
            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors"></div>

            {/* Play Button Icon */}
            <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center border border-white/50 group-hover:bg-white/30 transition-all">
                    <svg className="w-8 h-8 text-white ml-2" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z" />
                    </svg>
                </div>
            </div>

            {/* Title (Optional) */}
            {title && (
                <div className="absolute bottom-4 left-4 right-4 text-center">
                    <span className="text-white text-sm font-bold drop-shadow-md">{title}</span>
                </div>
            )}
        </div>
    );
};

export default VideoCard;
